module.exports = __webpack_public_path__ + "_assets/img/scanner.f207697b.svg";